import { css } from "@emotion/react";
import { useTheme } from "@emotion/react";

const useStyles = () => {
  const theme = useTheme() as any;

  return {
    pageHeader: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
    `,
    pageTitle: css`
      font-family: "Open Sans", sans-serif;
      font-size: 24px;
      font-weight: 700;
      color: ${theme?.navy || "#1f2d3d"};
      margin: 0;
    `,
    cardHeader: css`
      background: #ffffff;
      color: ${theme?.navy || "#1f2d3d"};
    `,
    headerRow: css`
      display: flex;
      align-items: center;
    `,
    title: css`
      font-family: "Open Sans", sans-serif;
      font-size: 24px;
      font-weight: 700;
      text-align: center;
    `,
    selectedToolbar: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      margin-bottom: 8px;
      background: ${theme?.white || "#ffffff"};
      border: 1px solid ${theme?.gray || "#e0e0e0"};
      border-radius: 4px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    `,
    selectedMessage: css`
      font-weight: 600;
      padding-right: 16px;
      border-right: 1px solid ${theme?.gray || "#e0e0e0"};
    `,
    selectedIcons: css`
      display: flex;
      gap: 16px;
      cursor: pointer;
    `,
    statusPill: css`
      display: inline-block;
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
    `,
    statusBuilding: css`
      background: ${theme?.gray || "#e0e0e0"};
      color: #555;
    `,
    statusBeta: css`
      background: ${theme?.yellow || "#fff4cc"};
      color: #7a5a00;
    `,
    statusReleased: css`
      background: ${theme?.seafoam || "#d3f0e8"};
      color: #14633e;
    `,
    monospace: css`
      font-family: "Source Code Pro", monospace;
      font-size: 13px;
    `,
    nameCell: css`
      color: ${theme?.teal || "#1f7a8c"};
      cursor: pointer;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    `,
    emptyState: css`
      text-align: center;
      padding: 48px;
    `,
    keyPreview: css`
      font-family: "Source Code Pro", monospace;
      font-size: 13px;
      color: #666;
      margin-top: 4px;
    `,
    helperText: css`
      font-size: 12px;
      color: #888;
      margin-top: 4px;
    `,
  };
};

export default useStyles;
